const SIDEBAR_ITEM_TYPE = {
  LINK: 1,
  TITLE: 2,
  CATEGORY: 3
}

export default SIDEBAR_ITEM_TYPE
